import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { IMG, VALUES, STATS } from "../data/content";

export default function About() {
  return (
    <>
      <PageHeader
        testid="about-page-header"
        overline="About the Studio"
        title={["Warm minimalist Indian craft,", "European precision."]}
        intro="Aurea Living is a Hyderabad atelier of architects, interior designers and master craftspeople who design, build and style under one roof."
      />

      <section className="container-lux pb-24" data-testid="about-founder-section">
        <div className="grid gap-14 lg:grid-cols-12 items-center">
          <Reveal className="lg:col-span-5">
            <div className="img-arch overflow-hidden aspect-[3/4] max-w-md mx-auto lg:mx-0">
              <img
                src={IMG.principal}
                alt="Principal designer of Aurea Living in the studio"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>
          <div className="lg:col-span-7">
            <Reveal>
              <p className="overline-label">Principal Designer</p>
              <h2 className="mt-4 font-serif font-light text-3xl sm:text-4xl text-ink">
                “We build rooms the way Hyderabad builds evenings — slowly,
                warmly, and to last.”
              </h2>
              <p className="mt-7 max-w-2xl text-[15px] font-light leading-relaxed text-stone-warm">
                Trained in architecture and raised on the wood-and-brass
                workshops of the old city, our principal leads every project
                from the first site visit to the last shelf of styling. The
                studio deliberately stays small: a handful of homes a year, each
                one visited weekly, each one detailed in our own workshop.
              </p>
              <p className="mt-5 max-w-2xl text-[15px] font-light leading-relaxed text-stone-warm">
                What binds the team is a conviction that luxury is not marble —
                it is measure. Drawings that resolve every junction, budgets
                that are itemised to a rupee, and handovers that arrive on the
                date we promised.
              </p>
            </Reveal>
            <Stagger className="mt-12 grid grid-cols-3 gap-6 border-t border-bronze/15 pt-8" gap={0.1}>
              {STATS.map((s) => (
                <StaggerItem key={s.label}>
                  <p className="font-serif text-3xl sm:text-4xl text-bronze">{s.value}</p>
                  <p className="mt-2 text-[11px] sm:text-xs font-medium tracking-wide text-stone-warm leading-snug">
                    {s.label}
                  </p>
                </StaggerItem>
              ))}
            </Stagger>
          </div>
        </div>
      </section>

      <section className="bg-sand py-24 lg:py-32" data-testid="about-values-section">
        <div className="container-lux">
          <Reveal className="mb-14 max-w-2xl">
            <p className="overline-label">What We Believe</p>
            <h2 className="mt-4 font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-ink">
              Three commitments, <span className="italic text-bronze">no asterisks.</span>
            </h2>
          </Reveal>
          <Stagger className="grid gap-10 md:grid-cols-3" gap={0.12}>
            {VALUES.map((v, i) => (
              <StaggerItem key={v.title} className="bg-white border border-bronze/10 p-8">
                <p className="font-serif text-5xl text-gold/40">{String(i + 1).padStart(2, "0")}</p>
                <h3 className="mt-5 font-serif text-2xl text-ink">{v.title}</h3>
                <p className="mt-4 text-[14px] font-light leading-relaxed text-stone-warm">
                  {v.desc}
                </p>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="container-lux py-24" data-testid="about-studio-section">
        <Reveal>
          <div className="relative overflow-hidden">
            <img
              src={IMG.studio}
              alt="Aurea Living studio space in Hyderabad"
              loading="lazy"
              className="w-full aspect-[16/9] md:aspect-[21/9] object-cover"
            />
            <div className="absolute inset-0 bg-espresso/45" />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              <p className="overline-label !text-gold">The Atelier</p>
              <p className="mt-4 font-serif font-light text-2xl sm:text-4xl text-ivory max-w-2xl">
                Madhapur, Hyderabad — visitors welcome with an appointment.
              </p>
              <Link to="/contact" data-testid="about-cta" className="btn-bronze mt-8">
                Plan a Visit
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
